import { TRACKER_MESSAGE_HISTORY_RECORD_STATE } from '@racemap/sdk/schema/trackers';
import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';

export const getSentAttempts = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): number =>
  message.historyRecords?.filter(
    (record) => record.statusCode === TRACKER_MESSAGE_HISTORY_RECORD_STATE.SENT,
  ).length || 0;
